import { render, staticRenderFns } from "./job_resourcing_form.vue?vue&type=template&id=4ad85bae"
import script from "./job_resourcing_form.vue?vue&type=script&lang=js"
export * from "./job_resourcing_form.vue?vue&type=script&lang=js"
import style0 from "./job_resourcing_form.vue?vue&type=style&index=0&id=4ad85bae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports